import React from "react";
import styled from "styled-components";

import Spinner from "../icons/Spinner";

import { bold, colors, fonts, spacing } from ".";

const Div = styled.div`
    text-align: center;
    ${spacing.padding["24-t-b"]};

    svg {
        display: inline-block;
        animation-name: spin;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    p {
        display: inline-block;
        position: relative;
        top: -0.325rem;
        margin-right: 0.625rem;
        color: ${colors.darkSkyBlue};
        ${fonts.typeScale[16]};
        ${bold};
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

const Loading = () => (
    <Div data-testid="loading-component">
        <p>Loading</p>
        <Spinner size="medium" fillColor={colors.darkSkyBlue} />
    </Div>
);

export { Loading };
